<template>
  <div>
    <div
      :class="isSidebarMinimized ? 's-minimized' : ''"
      class="sidebar-video-recording"
    >
      <i
        class="c-sidebar-nav-icon cil-video"
      />
      <div class="video-screen-recording-container">
        <VideoScreenRecording canvas-id="recordScreenAndVideoCanvasGlobal" />
      </div>
    </div>
  </div>
</template>
<script>

import VideoScreenRecording from "@frontend/components/modules/video-screen-recording/video-screen-recording.vue";

export default {
  name: 'GlobalVideoScreenRecording',
  components: {
    VideoScreenRecording
  },
  data() {
    return {
      isSidebarMinimized: false
    };
  },
  mounted() {
    const sidebar = document.getElementById('sidebar');
    if (!sidebar) return;

    const update = () => {
      this.isSidebarMinimized = sidebar.classList.contains('c-sidebar-minimized');
    };

    update();

    const observer = new MutationObserver(update);
    observer.observe(sidebar, {
      attributes: true,
      attributeFilter: ['class']
    });

    this._observer = observer;
  },
  beforeDestroy() {
    this._observer?.disconnect();
  }
}
</script>
<style  lang="scss">
  .sidebar-video-recording {
    position:relative; 
    display:flex;
    transition: opacity 0.3s ease-in-out;
    padding: 15px 15px 15px 17px;
    align-items:center;
    
    i {
      display:none;
    
      transition: opacity 0.3s ease-in-out;
    }
  }
  .sidebar-video-recording.s-minimized {
    margin-bottom: 50px !important;
    i {
      display:block;
      cursor:pointer;
     
    }
    i:hover {
      color:#fec350 !important;
    }
    .video-screen-recording-container {
      display: none;
     
      transition: opacity 0.3s ease-in-out;
      background: #007964;
    }
    
  }
  .sidebar-video-recording.s-minimized:hover {
    .video-screen-recording-container {
      display: flex !important;
      position: absolute;
      top: 0;
      left: 100%;
      width: 200px;
      height: 51px;
      padding: 9px 25px;
     
    }
  }
  .sidebar-video-recording.s-minimized:hover > .video-screen-recording-container .video-preview {
    margin-top: -200px !important;
    z-index: -1;
  }

  
  .video-screen-recording-container {
     display: flex;
     flex-wrap: nowrap;
     min-width: 200px;
     overflow: hidden;
     width: 100%;
    .btn-outline-info {
      color: #ffffff !important;
      border-color: rgba(255,255,255,0.7) !important;
      opacity: 0.8 !important;
    }
  }
  .video-screen-recording-container > .video-preview {
    padding-top:100px !important;
  }
  @media (max-width: 768px) {
    .video-screen-recording-container {
      display: flex !important;
     
    }
    .sidebar-video-recording i {
      display:none !important;
    }
    .sidebar-video-recording {
      padding-left:20px;
    }
  }
  
</style>
